module.exports = __webpack_public_path__ + "img/form-2@2x.01e964f.png";